import React from 'react';
import './blog-post.css';

import icecream1 from './pictures/icecream1.png';
import icecream2 from './pictures/icecream2.png';
import icecream3 from './pictures/icecream3.png';
import icecream4 from './pictures/icecream4.png';



//import reportWebVitals from './reportWebVitals';

const Icecream = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>Spring MM1: Ice Cream Social Recap</h2>
                    <p class="site-post-meta">April 13th, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>                   
                    Thank you for coming to our first spring member meeting: Ice Cream Social!
                    Everyone customized their own ice cream with various toppings and sauces. 
                    It was a relaxing event where everyone played board games, ate snacks, and socialized!
                    <br></br>
                    <br></br>  
                     
                    </p>
                     <img src={icecream1} alt=""/>
                     <img src={icecream2} alt=""/>
                     <img src={icecream3} alt=""/>
                     <img src={icecream4} alt=""/>
                 
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Icecream;

